/**
 * Stato di una installazione, calcolato in base allo stato delle singole macchine
 */
export enum InstallationStatusEnum {
    Unknown = -1,
    Ok = 0,
    Warning = 1,
    PartiallyBlocked = 2,
    Blocked = 3,
}

export function installationStatusEnumLabel(status: InstallationStatusEnum): string {
    switch (status) {
        case InstallationStatusEnum.Ok:
            return "enum.installation_status.ok";
        case InstallationStatusEnum.Warning:
            return "enum.installation_status.warning";
        case InstallationStatusEnum.PartiallyBlocked:
            return "enum.installation_status.partially_blocked";
        case InstallationStatusEnum.Blocked:
            return "enum.installation_status.blocked";
        default:
            return "common.unknown";
    }
}

export function installationStatusDescription(status: InstallationStatusEnum): string {
    switch (status) {
        case InstallationStatusEnum.Ok:
            return "enum.installation_status.okDescription";
        case InstallationStatusEnum.Warning:
            return "enum.installation_status.warningDescription";
        case InstallationStatusEnum.PartiallyBlocked:
            return "enum.installation_status.partially_blockedDescription";
        case InstallationStatusEnum.Blocked:
            return "enum.installation_status.blockedDescription";
        default:
            return "common.unknownDescription";
    }
}
